import React, { createContext, useContext, useEffect, useState } from 'react';

import { content, languages } from './data';

const STORAGE_KEY = 'ronda-lang';

const LanguageContext = createContext(null);

// Saved choice first, then the browser language; Spanish is the default.
const initialLanguage = () => {
  try {
    const saved = window.localStorage.getItem(STORAGE_KEY);
    if (languages.includes(saved)) return saved;
  } catch (e) {
    // Storage can be blocked; fall through to the browser language.
  }
  return (navigator.language || '').toLowerCase().startsWith('en') ? 'en' : 'es';
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(initialLanguage);
  const t = content[lang];

  useEffect(() => {
    document.documentElement.lang = lang;
    document.title = t.meta.title;
    document.querySelector('meta[name="description"]')?.setAttribute('content', t.meta.description);
    try {
      window.localStorage.setItem(STORAGE_KEY, lang);
    } catch (e) {
      // Not critical: the choice just won't be remembered.
    }
  }, [lang, t]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>{children}</LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
